











































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { emptyFn } from "@/fp";
import { pxToRem } from "@/common/dom.functions";
import { onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import { table_config } from "./table.config";
import SubfolderTableRow from "./SubfolderTableRow.vue";
import { UseLoading } from "@/common/composition/loading";
import { get_sub_folders } from "../../entities/folders";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import { EventBus } from "@/eventbus";
import { POPULATION_TYPE } from "@/common/models";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      backdropDismiss: true,
      width: "100rem",
      height: Math.min(65, pxToRem(innerHeight) * 0.9) + "rem",
    };

    const subs = {
      inv: emptyFn(),
    };

    const [is_loading, set_loading] = UseLoading(false).as_arr();
    const has_no_results = ref(false);
    const sub_folders = ref<Array<{ id: string; name: string; path: string }>>(
      []
    );
    const investigate_folder = async (item: {
      id: string;
      name: string;
      path: string;
    }) => {
      SharedState.investigation.investigate({
        name: item.name,
        id: item.id,
        type: POPULATION_TYPE.FOLDER,
        path: item.path,
      });
    };

    onMounted(async () => {
      subs.inv = EventBus.listen("investigate", investigate_folder);

      set_loading(true);
      try {
        // @ts-ignore
        const res = await get_sub_folders(props.modalData.folder_id);
        if (res.success) {
          sub_folders.value = [...res.value].sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          has_no_results.value = sub_folders.value.length === 0;
        } else {
          sub_folders.value = [];
          has_no_results.value = true;
          UseToast().show({
            type: ToastType.ALERT,
            msg: "Failed to load subfolders",
          });
        }
      } catch (e) {
        console.error("Failed to load subfolders", e);
        sub_folders.value = [];
        has_no_results.value = true;
      } finally {
        set_loading(false);
      }
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      modal_config,
      table_config,
      SubfolderTableRow,
      is_loading,
      sub_folders,
    };
  },
});
